import type { State } from 'store/types'

export const selectLanguage = (state: State) => state.i18nState.lang
